import { useFormik } from "formik";
import React from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useAppMutation } from "../../../api/fetchClient";
import { CHANGE_PASSWORD } from "../../../api/url";
import { adminLogo } from "../../../assets/image";


const ChangePassword = () => {
  const { mutate: changePassword } = useAppMutation();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Required"),
      newPassword: Yup.string().min(6, "Password too short").required("Required"),
    }),
    onSubmit: (values, { setSubmitting, setErrors }) => {
      changePassword(
        {
          url: CHANGE_PASSWORD,
          method: "PUT",
          data: {
            oldPassword: values.oldPassword,
            newPassword: values.newPassword,
          },
        },
        {
          onSuccess: () => {
            navigate("/admin");
          },
          onError: (err) => {
            setErrors({ submit: err.message });
          },
          onSettled: () => {
            setSubmitting(false);
          },
        }
      );
    },
  });

  return (
    <div className="min-h-[calc(100svh-100px)] flex items-center justify-center p-4">
      <div className="w-full max-w-[400px] bg-white rounded-2xl shadow-lg p-8">
        <div className="flex justify-center mb-6">
          <div className="w-14 h-14 rounded-xl flex items-center justify-center">
            <img src={adminLogo} alt="logo" />
          </div>
        </div>
        <h2 className="text-center text-2xl font-bold mb-6 text-dark">Change Password</h2>
        <form onSubmit={formik.handleSubmit} className="space-y-5">
          <div>
            <input
              id="oldPassword"
              name="oldPassword"
              type="password"
              placeholder="Old Password"
              className="w-full px-4 py-3 bg-gray-50 rounded-lg text-sm text-dark focus:outline-none"
              {...formik.getFieldProps("oldPassword")}
            />
            {formik.touched.oldPassword && formik.errors.oldPassword && (
              <p className="text-sm text-red-500">{formik.errors.oldPassword}</p>
            )}
          </div>
          <div>
            <input
              id="newPassword"
              name="newPassword"
              type="password"
              placeholder="New Password"
              className="w-full px-4 py-3 bg-gray-50 rounded-lg text-sm text-dark focus:outline-none"
              {...formik.getFieldProps("newPassword")}
            />
            {formik.touched.newPassword && formik.errors.newPassword && (
              <p className="text-sm text-red-500">{formik.errors.newPassword}</p>
            )}
          </div>

          {formik.errors.submit && (
            <div className="text-sm text-red-500 bg-red-50 p-3 rounded-lg text-center">{formik.errors.submit}</div>
          )}

          <button type="submit" className="w-full bg-primary text-white py-3 rounded-lg font-medium hover:bg-grey">
            Change Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
